import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@reservamos/elements';

/**
 * CollapsibleTriggerChevronText component.
 * Render a collapsible trigger button with chevron icon and text.
 * @param {object} props - isOpen, onClick, hideText, expandText.
 * @param {boolean} props.isOpen - Whether the collapsible is open.
 * @param {Function} props.onClick - Click handler function.
 * @param {string} props.hideText - Text to show when collapsible is open.
 * @param {string} props.expandText - Text to show when collapsible is closed.
 * @returns {JSX.Element}
 */
const CollapsibleTriggerChevronText = ({ isOpen, onClick, hideText, expandText }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="text-gray-500 hover:text-primary-strong group flex text-xs items-center gap-2 justify-end transition-colors duration-300"
    >
      {isOpen ? hideText : expandText}

      <span className="inline-flex h-8 w-8 items-center justify-center shadow-md bg-gradient-to-br from-primary-regular to-primary-strong rounded-full hover:from-primary-dark hover:to-primary-regular transition-all duration-200">
        {isOpen ? (
          <Icon type="ChevronUp" size="S" color="white" />
        ) : (
          <Icon type="ChevronDown" size="S" color="white" />
        )}
      </span>
    </button>
  );
};

CollapsibleTriggerChevronText.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  hideText: PropTypes.string.isRequired,
  expandText: PropTypes.string.isRequired,
};

export default CollapsibleTriggerChevronText;
